var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemoveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2 2.90909C10.4268 2.90909 9.8 3.56031 9.8 4.36364V5.81818H18.2V4.36364C18.2 3.5603 17.5732 2.90909 16.8 2.90909H11.2ZM5.6 8.72727V27.6364C5.6 28.4397 6.22679 29.0909 7 29.0909H21C21.7732 29.0909 22.4 28.4397 22.4 27.6364V8.72727H5.6ZM25.2 8.72727V27.6364C25.2 30.0464 23.3196 32 21 32H7C4.68042 32 2.8 30.0464 2.8 27.6364V8.72727H1.4C0.626801 8.72727 0 8.07605 0 7.27273C0 6.4694 0.626801 5.81818 1.4 5.81818H7V4.36364C7 1.95367 8.8804 0 11.2 0H16.8C19.1196 0 21 1.95368 21 4.36364V5.81818H26.6C27.3732 5.81818 28 6.4694 28 7.27273C28 8.07605 27.3732 8.72727 26.6 8.72727H25.2Z",
    fill: "#121212"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8004 13.0909C17.5736 13.0909 18.2004 13.7421 18.2004 14.5455V23.2727C18.2004 24.0761 17.5736 24.7273 16.8004 24.7273C16.0272 24.7273 15.4004 24.0761 15.4004 23.2727V14.5455C15.4004 13.7421 16.0272 13.0909 16.8004 13.0909Z",
    fill: "#121212"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2008 13.0909C11.974 13.0909 12.6008 13.7421 12.6008 14.5455V23.2727C12.6008 24.0761 11.974 24.7273 11.2008 24.7273C10.4276 24.7273 9.80078 24.0761 9.80078 23.2727V14.5455C9.80078 13.7421 10.4276 13.0909 11.2008 13.0909Z",
    fill: "#121212"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/RemoveIcon.65c0f90a3e4d6c6a8b29b712907eedb7.svg";
export { ForwardRef as ReactComponent };